import { Howl, Howler } from 'howler'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import { gsap } from "gsap"
import { breakpoint } from '../utilities/screen_setup'

gsap.registerPlugin(ScrollTrigger)

let screenWidth = breakpoint('full')

//Can rewrite to viewpoints
if (breakpoint('full') > breakpoint('xxl')) {
  let fontCoef = screenWidth / 1440
  let fontSize = Math.floor(16 * fontCoef)
  fontSize = fontSize > 32 ? 32 : fontSize
  $('html').css('font-size', fontSize + 'px')
}

var drone = $('#drone')

/** Drone relocate **/
var droneOnImage = $('#drone-on-image')

var sound = new Howl({
  src: [$('.swap-volume').data('audio')],
  loop: true,
  volume: 0.5,
})

$(document).ready(function () {

  $('.swap-volume').on('click', function () {
    if ($(this).hasClass('active')) {
      sound.stop()
      $(this).removeClass('active')
    } else {
      sound.play()
      $(this).addClass('active')
    }

  })

})

//$(window).on('load', function (e) {
$(document).ready(function () {

  setTimeout(function(){

      function droneFlyInImage () {
        drone.animate({ bottom: '-50%' }, function () {
          droneOnImage.animate({ left: '5%', top: '6vh' })
        })
      }

      function droneFlyInVideo () {
        if (droneOnImage.length) {
          droneOnImage.animate({ left: '70%', top: '-50%' }, function () {
            setupDrone()
          })
        } else {
          setupDrone()
        }
      }

      if (breakpoint('full') > breakpoint('md')) {

        ScrollTrigger.create({
          trigger: '#drone-fly-video-trigger',
          start: 'top center',
          end: 'bottom center',
          onEnter: droneFlyInVideo,
          onEnterBack: droneFlyInVideo,
          onLeave: droneFlyInImage,
          //markers: true
        })

      } else {
        setupDrone()
      }

  }, 2500)

  ScrollTrigger.create({
    trigger: '#drone-fly-video-play-trigger',
    start: 'top center',
    end: 'bottom center',
    //onEnter: droneFlyInVideo,
    //onEnterBack: droneFlyInVideo,
    //onLeave: droneFlyInImage,
    //markers: true
  })

})

function setupDrone () {
  let height = drone.height()
  let bottom = height * 0.45

  drone.css('bottom', '-' + bottom + 'px')
}

